import { Observable } from 'rxjs';
import { ReturnTypeDisclaimerLimits } from '@src/core/domain/limit-disclaimer/limits-diclaimer.model';
export abstract class LimitsDisclaimerRepositories {
  abstract getDisclaimers(type: {}): Observable<ReturnTypeDisclaimerLimits>;
}
